import type { HTMLAttributes } from 'react'
import { cn } from '@/lib/cn'

export type BadgeTone = 'neutral' | 'success' | 'warning' | 'danger' | 'info' | 'accent'

const TONE_CLASS: Record<BadgeTone, string> = {
  neutral: 'bg-[var(--surface-inset)] text-[var(--text-secondary)] border-[var(--border-subtle)]',
  success: 'bg-[var(--success-soft)] text-[var(--success)] border-[var(--success)]/25',
  warning: 'bg-[var(--warning-soft)] text-[var(--warning)] border-[var(--warning)]/25',
  danger: 'bg-[var(--danger-soft)] text-[var(--danger)] border-[var(--danger)]/25',
  info: 'bg-[var(--info-soft)] text-[var(--info)] border-[var(--info)]/25',
  accent: 'bg-[var(--accent-soft)] text-[var(--accent)] border-[var(--accent)]/25',
}

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone
  /** Ponto colorido decorativo. O rótulo textual sempre acompanha. */
  dot?: boolean
}

/** O texto do badge é obrigatório: a cor nunca é o único portador da informação. */
export function Badge({ tone = 'neutral', dot = false, className, children, ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5',
        'text-xs font-medium leading-5 whitespace-nowrap',
        TONE_CLASS[tone],
        className,
      )}
      {...props}
    >
      {dot && <span aria-hidden="true" className="size-1.5 shrink-0 rounded-full bg-current" />}
      {children}
    </span>
  )
}
